import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";

export default function GamingLicenseAnjouan () {

    return (
        <main className='main'>

            <IntroSection
                title="Gaming License – Anjouan (Comoros)"
                subtitle="Launch Your iGaming Business with AOFA Licensing"
                description =
                    "<b>Anjouan</b>, part of the <b>Union of Comoros</b>, has rapidly gained recognition as a <b>cost-effective</b> and <b>startup-friendly jurisdiction</b> for <b>online gambling licenses</b>. Regulated by the <b>Anjouan Offshore Finance Authority (AOFA)</b>, it offers one of the <b>fastest</b> and <b>most affordable paths</b> to operate <b>casinos</b>, <b>sportsbooks</b>, <b>lotteries</b>, and <b>crypto gaming platforms</b>."
                badges={[
                    "Online Casino License",
                    "Sportsbook License",
                    "Lottery & Sweepstakes",
                    "Crypto Gaming & eSports"
                ]}
                buttonText="Request an Anjouan Gaming Proposal →"
                buttonLink="/contact"
                imageSrc={require("../../../assets/images/services/gaming-license-anjouan-hero.png")}
                imageAlt="Gaming License Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Anjouan?'
                        subtitle="Operating without a license exposes your business to:"
                        blocks={[
                            {
                                subtitle: "With a gaming license, you gain:",
                                items: [
                                    { title: "No Capital Requirement", text: "unlike Malta, Isle of Man, or Mwali" },
                                    { title: "Fast Approvals", text: "license in as little as 4–6 weeks" },
                                    { title: "Affordable", text: "setup & renewal costs are among the lowest worldwide" },
                                    { title: "Global Reach", text: "operate internationally under AOFA framework" },
                                    { title: "Crypto-Friendly", text: "ideal for blockchain casinos, NFT games, and DeFi gambling" }
                                ]
                            }
                        ]}
                    />

                    <FeatureCards
                        title='What the License Covers'
                        subtitle='An Anjouan Gaming License allows you to operate:'
                        features={
                            [
                                { title: "Online Casino", text: "slots, table games, live dealer, RNG systems" },
                                { title: "Sportsbook & Betting", text: "fixed odds, live betting, eSports, virtual sports" },
                                { title: "Lottery & Sweepstakes", text: "draws, prize competitions, and number games" },
                                { title: "Poker & Skill Games", text: "poker rooms, fantasy sports, skill-based gaming" },
                                { title: "Crypto Gaming", text: "provably fair blockchain games, tokenized casinos, NFT-based platforms" },
                                { title: "White-Label Operations", text: "manage multiple brands under one license" }
                            ]
                        }
                    />

                    <LocationTimeline
                        title='Benefits of an Anjouan Gaming License'
                        item={
                            [
                                { title: "Online Casino", text: "slots, table games, live dealer, RNG systems" },
                                { title: "Sportsbook & Betting", text: "fixed odds, live betting, eSports, virtual sports" },
                                { title: "Lottery & Sweepstakes", text: "draws, prize competitions, and number games" },
                                { title: "Poker & Skill Games", text: "poker rooms, fantasy sports, skill-based gaming" },
                                { title: "Crypto Gaming", text: "provably fair blockchain games, tokenized casinos, NFT-based platforms" },
                                { title: "White-Label Operations", text: "manage multiple brands under one license" }
                            ]
                        }
                    />

                    {/* Services */}
                    <ServiceCards
                        title='Licensing Process'
                        services={
                            [
                                { title: "Consultation & Strategy", text: "choose your vertical (casino, sportsbook, lottery, hybrid)" },
                                { title: "Company Incorporation", text: "establish an IBC in Mwali (Comoros)" },
                                { title: "Compliance Setup", text: "AML/KYC manuals, risk framework, business plan" },
                                { title: "Application Filing", text: "Offshore Advisory submits application to MISA" },
                                { title: "Approval & License Grant", text: "typically within 2–3 weeks" }
                            ]

                        }
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                description: "(faster than Curaçao, Malta, or Mwali).",
                                duration: "4–6 weeks",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Setup Costs",
                                description: "starting from USD 19,000–20,000+",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Annual Renewal Fees",
                                description: "very competitive vs Curaçao or Malta.",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Capital Requirement",
                                description: "None",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Authorized agent with AOFA licensing expertise" },
                                { text: "End-to-end solution: incorporation, license application, compliance setup" },
                                { text: "Access to white-label casino & sportsbook software" },
                                { text: "PSP & crypto payment integrations" },
                                { text: "Affiliate network & marketing guidance" }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title='Ready to launch your casino or sportsbook?'
                         description=
                             "With <b>no capital requirements</b>, <b>fast approvals</b>, and <b>low costs</b>, <b>Anjouan</b> is one of the <b>best offshore options</b> for <b>iGaming startups</b>."
                         buttonText='Book an Anjouan Gaming License Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Is there a capital requirement for an Anjouan gaming license?",
        content: [
            { type: "answer", text: "No — there are no minimum capital requirements, unlike Malta or Isle of Man." },
        ],
    },
    {
        question: "How long does it take to get licensed?",
        content: [
            { type: "answer", text: "Typically 4–6 weeks, one of the fastest offshore approvals." },
        ],
    },
    {
        question: "Can I accept crypto payments?",
        content: [
            { type: "answer", text: "Yes — Anjouan is crypto-friendly, supporting BTC, ETH, USDT, and tokenized casinos." },
        ],
    },
    {
        question: "Can one license cover multiple verticals?",
        content: [
            { type: "answer", text: "Yes — casino, sportsbook, lottery, and skill games can be combined under one license." },
        ],
    },
    {
        question: "Is the license globally recognized?",
        content: [
            { type: "answer", text: "Yes — it is widely used in the offshore iGaming industry and accepted by PSPs, affiliates, and providers." },
        ],
    },
];

const testimonialsData =
    [
        {
            quote: "Offshore Advisory helped us get an Anjouan license in under 5 weeks. Fast, affordable, and perfect for our startup casino.",
            author: "Mark J.",
            role: "Casino Operator"
        },
        {
            quote: "We launched a crypto gaming platform under AOFA. Offshore Advisory guided us through compliance and PSP setup smoothly.",
            author: "Elena K.",
            role: "Blockchain Gaming Founder"
        }
    ]
;